import PeopleIcon from "@mui/icons-material/People"

const PeopleGradientIcon = () => (
  <svg width='24' height='24' viewBox='0 0 24 24'>
    <defs>
      <linearGradient id='sharieGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
        <stop offset='0%' stopColor='#ff4f93' />
        <stop offset='100%' stopColor='#364fbf' />
      </linearGradient>
    </defs>

    <path
      fill='url(#sharieGradient)'
      d='M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0
         c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2
         c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0
         c-.29 0-.62.02-.97.05 1.16.84 1.97 2.06 1.97 3.45V19h6v-2.5
         c0-2.33-4.67-3.5-7-3.5z'
    />
  </svg>
)
export default PeopleGradientIcon
